module.exports = {"server":"https://dotsc.ugpti.ndsu.nodak.edu:3005","homeUrl":"https://dotsc.ugpti.ndsu.nodak.edu","dev":false,"enableTooltip":false,"homepage":"/GRIT"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 16
// module chunks = 0